import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/utils/ReactQuery';
import DataTable from '@/components/common/DataTable';
import { useReferenceMaterialLessons } from '@/components/admin/RefMatTaggedContentTable/useReferenceMaterialLessons';
import { AddTaggedContentButton } from '@/components/admin/RefMatTaggedContentTable/AddTaggedContentButton';
import DeleteModelReferenceMaterialButton from './DeleteModelReferenceMaterialButton';

interface RefMatTaggedContentTableProps {
  referenceMaterial: {
    id: number;
    title: string;
  };
}

const RefMatTaggedContentTable = ({ referenceMaterial }: RefMatTaggedContentTableProps) => {
  const { data: lessons, isLoading } = useReferenceMaterialLessons(referenceMaterial.id);

  const resources = lessons.flatMap(lesson => (
    lesson.programs.map(program => ({
      actions: '',
      lessonId: lesson.id,
      lessonUnitTitle: lesson.titles_for_programs[program.id],
      programId: program.id,
      programTitle: program.full_title_with_edition,
      programs: lesson.programs,
    }))
  ));

  return (
    <div>
      <AddTaggedContentButton referenceMaterial={referenceMaterial} />
      <DataTable
        handleResourcesManually
        columnDefs={[
          { className: 'tw-font-bold tw-text-nowrap', targets: 0 },
          { targets: 1, title: 'Lesson', width: '45%' },
          {
            createdCell: (td, _arg, row) => {
              ReactDOM.render(
                <QueryClientProvider client={queryClient}>
                  <DeleteModelReferenceMaterialButton referenceMaterial={referenceMaterial} row={row} />
                </QueryClientProvider>,
                td,
              );
            },
            sortable: false,
            targets: 2,
            width: '11%',
          },
        ]}
        columnMapping={[]}
        columns={['programTitle', 'lessonUnitTitle', 'actions']}
        isLoading={isLoading}
        resources={resources}
      />
    </div>
  );
};

const RefMatTaggedContentTableWrapper = (props: RefMatTaggedContentTableProps) => (
  <QueryClientProvider client={queryClient}>
    <RefMatTaggedContentTable {...props} />
  </QueryClientProvider>
);

export default RefMatTaggedContentTableWrapper;
